import React, {
  useState,
  useEffect,
  useContext,
  useCallback,
  useMemo,
} from 'react'
import { getDbVersion, getGitVersionsInformation } from 'api/pgads'
import { ErrorContext } from 'context'
import { Tabs } from 'antd'
// import { DATE_TIME_FORMAT_UI } from '../enum'
import { Title, CriteriaRow, Content, FullHeightSizer } from 'core/screen-util'
import { connect } from 'react-redux'
import { getApiTargetInfo, getEnvConfig, getPermitActions } from 'core'
import { Grid, virtualizedGridRenderer } from '@integec/grid-tools'
import { dateTimeCol, strCol } from '@integec/grid-tools/lib/cols'
import { hasAccesPermits, rowHeaderRender } from 'core/utils'
import * as ScreenPermissions from 'core/EventActions'
// const columns = [
//   {
//     title: 'Project Name',
//     dataIndex: 'projectName',
//     align: 'center',
//     width: 150,
//   },
//   {
//     title: 'Git Branch',
//     dataIndex: 'git.branch',
//     width: 150,
//     ellipsis: true,
//   },
//   {
//     title: 'Commit Point',
//     dataIndex: 'git.commit.id.abbrev',
//     align: 'center',
//     width: 100,
//   },
//   {
//     title: 'Commit Point',
//     dataIndex: 'git.commit.id',
//     align: 'center',
//     width: 200,
//   },
// ]

const gridColumns = [
  {
    display: 'Project Name',
    ident: 'projectName',
    align: 'center',
    width: 200,
    sortOrder: 'asc',
  },
  // {
  //   display: 'Git Branch',
  //   ident: 'git.branch',
  //   width: 320,
  //   ellipsis: true,
  // },
  {
    display: 'Commit Point',
    ident: 'git.commit.id.abbrev',
    align: 'center',
    width: 200,
    sortOrder: 'asc',
  },
  {
    display: 'Commit Point',
    ident: 'git.commit.id',
    align: 'center',
    width: 400,
    sortOrder: 'asc',
  },
]

const dbcolumns = [
  dateTimeCol({
    ident: 'updateDate',
    display: 'Update Date',
    width: 200,
  }),
  strCol({
    ident: 'updateVersion',
    display: 'Update Version',
    width: 400,
  }),
]

const VersionsNyIso = ({ apiTargetInfo, actionPermits, envConfig }) => {
  const [versionData, setVersionData] = useState([])

  const { setError } = useContext(ErrorContext)
  const [dbVersion, setDBVersion] = useState([])
  const [activeKey, setActiveKey] = useState('App')

  const hasAdminPermission = useMemo(
    _ => {
      const adminMenu = hasAccesPermits({
        actionPermits,
        eventActions: [
          ScreenPermissions.IT_REGISTRATION,
          ScreenPermissions.CHANGE_PERMISSIONS,
          ScreenPermissions.ACCESS_PERMISSIONS,
        ],
        matchAny: true,
      })
      return adminMenu
    },
    [actionPermits]
  )
  // eslint-disable-next-line no-undef
  const uiGit = GIT_HASH

  const { extraMap = {} } = envConfig
  const { UI_RELEASE_IMAGE_TAG, API_RELEASE_IMAGE_TAG } = extraMap

  // eslint-disable-next-line no-undef
  const uiGitTag = UI_RELEASE_IMAGE_TAG || uiGit
  const apiTag = API_RELEASE_IMAGE_TAG
  // const uiGitTag = GIT_TAG || uiGit

  const api = versionData.find(f => f.projectName === 'lite-gads-api') || {}
  // const apiTag = api['git.tags']

  const apiCommitPoint = api['git.commit.id.abbrev']

  const mapToArray = useCallback(
    dataMap => {
      const data = Object.keys(dataMap).map(temp => {
        return {
          projectName: temp
            .split('/')
            .splice(-1)
            .shift(),
          ...dataMap[temp],
        }
      })

      // console.log(dataMap)
      const ndata = [
        { projectName: 'UI', 'git.commit.id.abbrev': uiGit },
        ...data,
      ]

      setVersionData(ndata)
    },
    [uiGit]
  )

  useEffect(() => {
    getGitVersionsInformation(apiTargetInfo).fork(setError, mapToArray)
    getDbVersion(apiTargetInfo).fork(setError, setDBVersion)
  }, [apiTargetInfo, mapToArray, setError])

  return (
    <>
      <CriteriaRow>
        <Title style={{ width: '170px' }}>Versions</Title>
      </CriteriaRow>
      <CriteriaRow
        style={{
          marginTop: '10px',
          display: 'grid',
          gridTemplateColumns: '200px auto',
          width: '100%',
        }}
      >
        <div
          style={{
            marginRight: '20px',
            display: 'grid',
            justifyContent: 'end',
          }}
        >
          <b>UI Version :</b>
        </div>
        <div style={{ marginRight: '20px' }}> {uiGitTag || uiGit}</div>

        <div
          style={{
            marginRight: '20px',
            display: 'grid',
            justifyContent: 'end',
          }}
        >
          <b>API Version :</b>
        </div>
        <div> {apiTag || apiCommitPoint}</div>
      </CriteriaRow>
      {hasAdminPermission && (
        <Content style={{ paddingTop: '24px' }}>
          <FullHeightSizer heightOffset={290}>
            {({ height, width }) => (
              <Tabs activeKey={activeKey} onChange={setActiveKey}>
                <Tabs.TabPane title="App" key="App" tab="App Version">
                  <div
                    style={{
                      height: height - 20 + 'px',
                      width: width - 50 + 'px',
                    }}
                  >
                    <Grid
                      data={versionData}
                      headers={gridColumns}
                      render={virtualizedGridRenderer({
                        rowHeaderRender,
                        height: height - 40,
                        width: width - 50,
                        headerRowHeight: 30,
                      })}
                      initialSortOptions={gridColumns}
                      sortOptions={gridColumns}
                      selectionType="row"
                      selectionMode="single"
                    />
                  </div>
                </Tabs.TabPane>
                <Tabs.TabPane
                  title="DB Version"
                  key="DB"
                  tab="DB Release Version"
                >
                  <div
                    style={{
                      height: height - 20 + 'px',
                      width: '700px',
                    }}
                  >
                    <Grid
                      data={dbVersion}
                      headers={dbcolumns}
                      render={virtualizedGridRenderer({
                        rowHeaderRender,
                        height: height - 40,
                        width: 700,
                        headerRowHeight: 30,
                      })}
                      initialSortOptions={dbcolumns}
                      sortOptions={dbcolumns}
                      selectionType="row"
                      selectionMode="single"
                    />
                  </div>
                </Tabs.TabPane>
              </Tabs>
            )}
          </FullHeightSizer>
        </Content>
      )}
    </>
  )
}
const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
  envConfig: getEnvConfig(state),
  actionPermits: getPermitActions(state),
})

export default connect(mapStateToProps)(VersionsNyIso)
